import type {
  FlattenFormSchema,
  FlattenSchema,
  FormAllAvailableKeys,
  FormFlattenKey,
  FormSchema,
} from '@modules/forms/components/VForm/types';
import type { IFormInput } from '@modules/forms/types';
import { EFormInputTypes } from '@modules/forms/enums';
import {
  isEnumOfType,
  isKeyOf,
  isObject,
} from '@utils/guards';

export function flattenSchema<TSchema, TStopSchemaKeys extends FormAllAvailableKeys<TSchema>>(
  schema: FormSchema<TSchema, TStopSchemaKeys>,
  prefix = '',
): FlattenFormSchema<FlattenSchema<TSchema, TStopSchemaKeys>> {
  return Object.entries(schema).reduce((accumulator, [key, value]) => {
    if (isSchemaInput(value)) {
      Object.assign(accumulator, {
        [`${prefix}${key}`]: value,
      });
    } else {
      Object.assign(accumulator, flattenSchema(value as FormSchema<TSchema, TStopSchemaKeys>, `${prefix}${key}.`));
    }

    return accumulator;
  }, {} as FlattenFormSchema<FlattenSchema<TSchema, TStopSchemaKeys>>);
}

export function isKeyOfSchema<
  TSchema,
  TStopSchemaKeys extends FormAllAvailableKeys<TSchema>,
  TResult = FormFlattenKey<TSchema, TStopSchemaKeys>,
>(
  flattenedSchema: FlattenFormSchema<FlattenSchema<TSchema, TStopSchemaKeys>>,
  key: unknown,
): key is TResult {
  return isKeyOf(flattenedSchema, key);
}

export function isSchemaInput(argument: unknown): argument is IFormInput<unknown> {
  return isObject(argument) && !!argument.type && isEnumOfType(EFormInputTypes)(argument.type);
}
